// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"L_PH_TheComp__IVKut"};